<template>
  <div class="followers-card desktop-shadow-card desktop-white-bg rounded">
    <div class="card-header">
      <h4 class="card-header-title">
        <icon type="users" class="mr-2" /> Followers
      </h4>
      <div class="d-flex justify-content-end my-3 my-md-0">
        <div class="d-flex align-items-center mr-auto mr-md-5 text-dark">
          <span>
            <b v-if="!loading">
              <i class="fas fa-spin fa-circle-notch" v-if="busy"></i>
              {{ busy ? "" : followers.length }}/{{ total }}</b
            >
            <i class="fas fa-spin fa-circle-notch" v-if="loading"></i>
            Follower{{ loading || total != 1 ? "s" : "" }}
          </span>
        </div>
        <select
          v-model="subscriptionStatus"
          :disabled="loading"
          @change="getFilteredFollowers()"
          class="form-control row m-0 w-auto"
        >
          <option
            v-for="subscriptionStatus in subscriptionStatuses"
            :value="subscriptionStatus.value"
            :key="subscriptionStatus.value"
          >
            {{ subscriptionStatus.label }}
          </option>
        </select>
      </div>
    </div>
    <alert
      v-if="!loading && !followers.length"
      class="my-4 mx-lg-4 mobile-tablet-white-bg mobile-tablet-shadow-card"
      >No followers yet!</alert
    >
    <alert
      v-if="loading"
      type="loader"
      color="light"
      class="my-4 mx-lg-4 mobile-tablet-white-bg mobile-tablet-shadow-card"
    />
    <table class="table table-striped mb-0" v-if="!loading && followers.length">
      <thead>
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>Occupation</th>
          <th>Type</th>
          <th class="text-center">Subscribed</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="follower in followers"
          :key="follower.email"
          class="mobile-tablet-shadow-card rounded"
        >
          <td>
            <b class="mobile-tablet-only mr-2">Name:</b>{{ follower.name }}
          </td>
          <td>
            <b class="mobile-tablet-only mr-2">Email:</b>
            {{ follower.email }}
          </td>
          <td>
            <b class="mobile-tablet-only mr-2">Occupation:</b>
            {{ follower.occupation }}
          </td>
          <td>
            <b class="mobile-tablet-only mr-2">Type:</b>
            {{ follower.type }}
          </td>
          <td class="d-flex justify-content-lg-center align-items-center">
            <b class="mobile-tablet-only mr-2">Subscribed:</b>
            <img
              class="subscriber-icon"
              :src="
                follower.isSubscriber
                  ? '/images/subscriber.png'
                  : '/images/notSubscriber.png'
              "
              :alt="follower.isSubscriber ? 'Subscriber' : 'Not Subscriber'"
              :title="follower.isSubscriber ? 'Subscriber' : 'Not Subscriber'"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <mugen-scroll :handler="loadMore" :should-handle="!busy && !loading">
      <alert
        v-if="busy"
        class="text-center p-2 mb-0 mobile-tablet-loadmore mobile-tablet-shadow-card"
        ><i class="fas fa-spin fa-circle-notch mr-2"></i>Loading more
        followers...</alert
      >
    </mugen-scroll>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import MugenScroll from "vue-mugen-scroll";

export default {
  name: "Followers",
  components: {
    MugenScroll,
  },
  data() {
    return {
      limit: 50,
      busy: false,
      subscriptionStatus: -1,
      subscriptionStatuses: [
        { value: -1, label: "Subscription Status" },
        { value: 1, label: "Subscribed" },
        { value: 2, label: "Not Subscribed" },
      ],
    };
  },
  computed: {
    ...mapState(["vendors"]),
    ...mapState({
      followers: (state) => state.followers.pagination.data,
      current: (state) => state.followers.pagination.current,
      total: (state) => state.followers.pagination.total || 0,
      loading: (state) => state.followers.loading,
    }),
    loggedInUser: function () {
      return Auth.user.get();
    },
    vendor: function () {
      return this.vendors.single;
    },
  },
  mounted() {
    if (!this.vendors.single) {
      this.$store.dispatch("vendors/get", { id: this.$route.params.id });
    }
    this.getVendorFollowers({ id: this.$route.params.id, limit: this.limit });
  },
  methods: {
    ...mapActions({
      getVendorFollowers: "followers/get",
    }),
    getFilteredFollowers: function (page) {
      const vendorId = this.$route.params.id;
      const data = {
        limit: this.limit,
        id: vendorId,
      };

      if (page) {
        data.page = page;
      }
      if (this.subscriptionStatus != -1) {
        data.subscribers = this.subscriptionStatus;
      }
      return this.getVendorFollowers(data);
    },
    loadMore() {
      if (this.followers.length < this.total) {
        this.busy = true;
        this.getFilteredFollowers(this.current + 1).then(() => {
          this.busy = false;
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.subscriber-icon {
  width: 35px;
}
@media (max-width: 1024px) {
  .followers-card {
    .subscriber-icon {
      width: 25px;
    }
    .card-header {
      padding: 0 !important;
    }
    table {
      display: flex;
    }
    thead {
      display: none;
    }
    tbody {
      width: 100%;
    }
    tr {
      display: flex;
      flex-direction: column;
      margin-bottom: 24px;
      padding: 8px;
      box-shadow: 0 0.75rem 1.5rem rgb(18 38 63 / 3%);
      td {
        padding: 0 4px;
        text-align: left !important;
        border: 0 !important;
        b {
          display: inline-block;
          padding: 4px 0;
        }
        .text-muted,
        &.text-muted {
          color: #152e4d !important;
        }

        &.actions-td {
          text-align: center !important;
          margin-bottom: 8px;
          margin-top: 12px;
          padding-top: 12px;
          border-top: 1px solid #ccc !important;
        }
      }
    }
  }
}

@media (max-width: 767px) {
  .followers-card {
    .card-header {
      display: block;
      height: auto;
    }
  }
}
</style>
